/* eslint-disable @typescript-eslint/no-explicit-any*/
import type { Vue } from 'vue-facing-decorator'; // if not already imported

type VueInstance = InstanceType<typeof Vue>;

const shortcuts: { [key: string]: { callback: () => void; parent: VueInstance }[] } = {};
export function registerShortcut(key: string, parent: VueInstance, callback: () => void): void {
  if (!shortcuts[key]) shortcuts[key] = [];
  shortcuts[key].push({ callback: callback, parent: parent });
  setListener();
}

export function unregisterShortcut(key: string, parent: VueInstance): void {
  const index = shortcuts[key].findIndex((item) => item.parent === parent);
  if (index > -1) shortcuts[key].splice(index, 1);
  if (shortcuts[key].length === 0) {
    delete shortcuts[key];
    setListener();
  }
}

function setListener(): void {
  if (Object.keys(shortcuts).length === 1) {
    window.addEventListener('keydown', handleKeydown);
  } else if (Object.keys(shortcuts).length === 0) {
    window.removeEventListener('keydown', handleKeydown);
  }
}

function handleKeydown(event: KeyboardEvent) {
  if ((event.target as any).nodeName === 'BODY') {
    if (shortcuts[event.key]) {
      for (const callback of shortcuts[event.key]) callback.callback();
    }
  }
}
